// Booking waitlist (revenue recovery). When capacity blocks a slot the guest
// can leave contact details; process_waitlist (server cron) re-probes capacity
// and messages first-come-first-served offers when space frees up.

import { supabase } from "../config";
import type { BookingWindow } from "./booking";

export async function joinBookingWaitlist(input: {
  serviceId: string;
  window: BookingWindow;
  name: string | null;
  email: string | null;
  phone: string | null;
}): Promise<{ ok: boolean; already?: boolean; reason?: string }> {
  const { data, error } = await supabase.rpc("join_booking_waitlist", {
    p_service_id: input.serviceId,
    p_starts_at: input.window.starts_at,
    p_ends_at: input.window.ends_at,
    p_party_size: input.window.party_size,
    p_guest_name: input.name,
    p_guest_email: input.email,
    p_guest_phone: input.phone,
  });
  if (error || !data) return { ok: false, reason: error?.message ?? "network_error" };
  return data as { ok: boolean; already?: boolean; reason?: string };
}
